import React from 'react';
import styled from 'styled-components';

export default styled(({ className }) => (
  <svg
    className={className}
    aria-hidden="true"
    data-icon="factory"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 34 34"
  >
    <path
      fill="currentColor"
      d="M7.483 3.91c.424.007.804.394.844.8l.003.05v7.814l3.06 1.644v-3.335c-.008-.558.622-.985 1.136-.812l.05.018.048.023 8.286 4.148v-3.377c-.008-.558.622-.985 1.136-.812l.05.018.048.023 9.521 4.76a.867.867 0 0 1 .464.71l.001.058v13.6a.88.88 0 0 1-.796.848l-.054.002H2.72a.879.879 0 0 1-.848-.796l-.002-.054V4.76c0-.432.369-.818.796-.848l.054-.002h4.763zm-.853 1.7H3.57v22.78h26.86V16.17l-7.82-3.91v3.38c0 .571-.667.998-1.186.78l-.048-.022-8.286-4.138v3.382c-.005.574-.682.995-1.2.766l-.049-.023-4.76-2.55a.866.866 0 0 1-.448-.684l-.003-.061V5.61zm4.59 13.6c.432 0 .818.369.848.796l.002.054v4.08a.879.879 0 0 1-.796.848l-.054.002H6.46a.879.879 0 0 1-.848-.796l-.002-.054v-4.08c0-.432.369-.818.796-.848l.054-.002h4.76zm8.16 0c.432 0 .818.369.848.796l.002.054v4.08a.879.879 0 0 1-.796.848l-.054.002h-4.76a.879.879 0 0 1-.848-.796l-.002-.054v-4.08c0-.432.369-.818.796-.848l.054-.002h4.76zm8.16 0c.432 0 .818.369.848.796l.002.054v4.08a.879.879 0 0 1-.796.848l-.054.002h-4.76a.879.879 0 0 1-.848-.796l-.002-.054v-4.08c0-.432.369-.818.796-.848l.054-.002h4.76zm-17.17 1.7H7.31v2.38h3.06v-2.38zm8.16 0h-3.06v2.38h3.06v-2.38zm8.16 0h-3.06v2.38h3.06v-2.38z"
    />
  </svg>
))``;
